import { Typography } from "@mui/material";

export default function FieldInfo({ title, value }) {
  const shouldHideTitle = () => {
    if (value === null || value === "" || value === " ") {
      return true;
    }
    return false;
  };
  return (
    <div className="w-full">
      <Typography className="pl-2 pt-2">
        {!shouldHideTitle() && (
          <div className="text-[0.65rem] font-bold normal-case text-gray-400">{title}</div>
        )}
        <div className="text-[0.65rem] font-bold normal-case text-gray-900">{value}</div>
      </Typography>
    </div>
  );
}
